import { useCallback, type KeyboardEventHandler } from 'react'

type Args = {
  disabled?: boolean
  isOpen?: boolean
  setOpen: (arg: ((prevState: boolean) => boolean) | boolean) => void
}

export function useButtonProps({
  isOpen = false,
  setOpen,
  disabled = false,
}: Args) {
  const onClick = useCallback(() => {
    setOpen((isOpen) => !isOpen)
  }, [setOpen])

  const onKeyDownHandler = useCallback<KeyboardEventHandler>(
    (event) => {
      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowUp':
        case 'Space': {
          event.preventDefault()
          event.stopPropagation()
          setOpen(true)

          break
        }
      }
    },
    [setOpen],
  )

  return {
    onKeyDown: onKeyDownHandler,
    onClick,
    disabled,
    isOpen,
  }
}
